import moment from "moment"

function generateLocation(index: number) {
  const countries = ["USA", "Canada", "Germany", "France", "Japan"]
  const cities = ["New York", "Toronto", "Berlin", "Paris", "Tokyo"]
  const areas = ["Area 1", "Area 2", "Area 3", "Area 4", "Area 5"]
  const warehouses = ["Warehouse A", "Warehouse B", "Warehouse C", "Warehouse D", "Warehouse E"]

  return {
    id: `loc_${index}`,
    code: `loc_${index}`,
    name: `Location ${index}`,
    type: index % 2 === 0 ? "Type A" : "Type B",
    address: `1234 Street ${index}`,
    country: countries[Math.floor(Math.random() * countries.length)],
    city: cities[Math.floor(Math.random() * cities.length)],
    area: areas[Math.floor(Math.random() * areas.length)],
    linkedWarehouse: warehouses[Math.floor(Math.random() * warehouses.length)],
    createdAt: moment()
      .subtract(Math.floor(Math.random() * 1000), "days")
      .toISOString()
  }
}

export const LOCATION_CONSTANTS = Array.from({ length: 10 }, (_, index) => generateLocation(index))

export const LOCATION_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" }
]
export const LOCATION_TYPE_OPTIONS = [
  { value: "RETAIL", label: "Retail" },
  { value: "WAREHOUSE", label: "Warehouse" }
]
